import { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  toInteger,
} from 'lodash';
import {
  Field2 as Field,
  TimeUtil,
} from 'vibeguide';
import Grid from '@mui/material/Grid';

const rankings = [
  {
    label: '',
    value: '',
  },
  {
    label: 'A',
    value: 'A',
  },
  {
    label: 'B',
    value: 'B',
  },
  {
    label: 'C',
    value: 'C',
  },
  {
    label: 'D',
    value: 'D',
  },
  {
    label: 'E',
    value: 'E',
  },
  {
    label: 'F',
    value: 'F',
  },
  {
    label: 'G',
    value: 'G',
  },
];

const ratings = [
  {
    label: '',
    value: '',
  },
  {
    label: 'G',
    value: 'g',
  },
  {
    label: 'Radio Edit',
    value: 'radio-edit',
  },
  {
    label: 'Explicit',
    value: 'explicit',
  },
];

const tempos = [
  {
    label: '',
    value: 0,
  },
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
  {
    label: '3',
    value: 3,
  },
  {
    label: '4',
    value: 4,
  },
  {
    label: '5',
    value: 5,
  },
];

class Information extends PureComponent {
  /**
   * When a field is changed
   */
  onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    const {
      onUpdate,
    } = this.props;

    let updatedValue = value;

    if (name === 'genre' || name === 'iswc') {
      updatedValue = value.split(',');
    } else if (name === 'tempo') {
      updatedValue = toInteger(value);
    }

    onUpdate({
      [name]: updatedValue,
    });
  };

  /**
   * When the tag field is changed
   */
  onChangeTag = (data) => {
    const {
      onUpdate,
    } = this.props;

    onUpdate(data);
  };

  onBlur = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    const {
      onUpdate,
    } = this.props;

    let updatedValue = value;

    if (name === 'genre' || name === 'iswc') {
      updatedValue = value.split(',').map(item => item.trim());
    }

    onUpdate({
      [name]: updatedValue,
    });
  };

  render() {
    const {
      user,
      name,
      artist,
      album,
      genre,
      copyright,
      isrc,
      iswc,
      releaseYear,
      durationSeconds,
      ranking,
      rating,
      ratingReason,
      tempo,
      source,
      tags,
      disableInput,
    } = this.props;

    const durationText = durationSeconds
      ? TimeUtil.convertDuration(durationSeconds, 'm:ss')
      : '';

    return (
      <Grid className="Information" spacing={2} container>
        <Grid size={6}>
          <Field
            type="text"
            label="Name"
            name="name"
            placeholder="Name"
            value={name || ''}
            tabIndex={1}
            disabled={disableInput}
            testId="song-name-input"
            onChange={this.onChange}
            required
            autoFocus
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="text"
            label="Artist"
            name="artist"
            placeholder="Artist"
            value={artist || ''}
            tabIndex={2}
            disabled={disableInput}
            testId="song-artist-input"
            onChange={this.onChange}
            required
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="text"
            label="Album"
            name="album"
            placeholder="Album"
            value={album || ''}
            tabIndex={3}
            disabled={disableInput}
            testId="song-album-input"
            onChange={this.onChange}
            required
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="text"
            label="Genre"
            name="genre"
            placeholder="Genre"
            value={genre || ''}
            tabIndex={4}
            disabled={disableInput}
            testId="song-genre-input"
            onChange={this.onChange}
            onBlur={this.onBlur}
            required
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="text"
            label="Record Label"
            name="copyright"
            placeholder="Record Label"
            value={copyright || ''}
            tabIndex={5}
            disabled={disableInput}
            testId="song-record-label-input"
            onChange={this.onChange}
            required
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="text"
            label="Release Year"
            name="releaseYear"
            placeholder="Release Year"
            value={releaseYear || ''}
            tabIndex={6}
            disabled={disableInput}
            testId="song-release-year-input"
            onChange={this.onChange}
            required
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="text"
            label="ISRC"
            name="isrc"
            placeholder="ISRC"
            value={isrc || ''}
            tabIndex={7}
            disabled={disableInput}
            testId="song-isrc-input"
            onChange={this.onChange}
            required
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="text"
            label="ISWC"
            name="iswc"
            placeholder="ISWC"
            value={iswc || ''}
            tabIndex={8}
            disabled={disableInput}
            testId="song-iswc-input"
            onChange={this.onChange}
            required
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="select"
            label="Rank"
            name="ranking"
            value={ranking || ''}
            options={rankings}
            tabIndex={9}
            disabled={disableInput}
            testId="song-ranking-select"
            onChange={this.onChange}
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="select"
            label="Rating"
            name="rating"
            value={rating || ''}
            options={ratings}
            tabIndex={10}
            disabled={disableInput}
            testId="song-rating-select"
            onChange={this.onChange}
            required
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="select"
            label="Tempo"
            name="tempo"
            value={tempo || 0}
            options={tempos}
            tabIndex={11}
            disabled={disableInput}
            testId="song-tempo-select"
            onChange={this.onChange}
            required
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="text"
            label="Reason"
            name="ratingReason"
            placeholder="Reason"
            value={ratingReason || ''}
            tabIndex={12}
            disabled={disableInput}
            testId="song-rating-reason-input"
            onChange={this.onChange}
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="text"
            label="Source"
            name="source"
            placeholder="Source"
            value={source || ''}
            tabIndex={13}
            disabled={disableInput}
            testId="song-source-input"
            onChange={this.onChange}
          />
        </Grid>

        <Grid size={6}>
          <Field
            type="text"
            label="Duration"
            name="duration"
            placeholder="Duration"
            value={durationText || ''}
            tabIndex={14}
            readOnly
            disabled
            testId="song-duration-input"
            onChange={this.onChange}
            required
          />
        </Grid>

        <Grid size={12}>
          <Field
            type="tags"
            label="Tags"
            name="tags"
            tagProps={{
              tags,
              allowTypes: ['admin'],
              showAs: 'list',
              assign: user.can('music.assign_tag'),
            }}
            disabled={disableInput}
            testId="song-tags-input"
            onChange={this.onChangeTag}
            tabIndex={15}
          />
        </Grid>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(Information);
